import { defineMessages } from 'react-intl';

const translations = {
  emptyMessage: {
    id: 'pages.shipmentView.parcels.emptyMessage',
    defaultMessage: 'No parcels',
    description: 'Empty message of the parcels grid',
  },
  buttons: {
    showTrackingInfo: {
      id: 'actions.showTrackingInfo',
      defaultMessage: 'show tracking info',
      description: 'label of the show tracking info button',
    },
  },
  parcelCard: {
    position: {
      label: {
        id: 'properties.position',
        defaultMessage: 'Position',
        description: 'label of the position property',
      },
    },
    shipAt: {
      label: {
        id: 'properties.shipAt',
        defaultMessage: 'Ship at',
        description: 'label of the ship at property',
      },
    },
  },
};

export default defineMessages(translations);
